export function CrackedLogo({ className = "", inverted = false }) {
  // White logo on black background - use directly on dark headers
  // For light backgrounds, invert the colors
  return (
    <img 
      src="/images/cracked-logo-white.png" 
      alt="Crack-ED" 
      className={`h-10 object-contain ${inverted ? '' : 'invert'} ${className}`}
    />
  );
}

export function CrackedLogoFull({ className = "", inverted = false }) {
  // For landing page - invert to show dark logo on light background
  // inverted=true means show white logo (for dark backgrounds)
  // inverted=false means show dark logo (for light backgrounds)
  return (
    <img 
      src="/images/cracked-logo-white.png" 
      alt="Crack-ED" 
      className={`h-12 object-contain ${inverted ? '' : 'invert'} ${className}`}
    />
  );
}
